/**
 * Row identity for a draft store.
 *
 * The two tables that use drafts key their rows differently — the opener edits
 * one pair per PATH (two tabs, A and B), the unwinder has no path at all — and
 * neither consumer should be building a string. `encode` is the only place
 * that knows the shape.
 */
export interface DraftKeySpec<K> {
  /** Namespace. Enters the `localStorage` key, so two stores never collide. */
  scope: string;
  encode: (key: K) => string;
}

export interface OpenerRowKey {
  pairId: string;
  path: 'a' | 'b';
}

export interface UnwinderRowKey {
  pairId: string;
}

/**
 * Opener rows are `(pairId, path)`.
 *
 * NOT keyed by rule id: the draft is an intention about the PAIR, and it has
 * to survive the moment a rule is created for it (that is the whole point of
 * staging config on a rule-less row). A rule-keyed draft would evaporate at
 * exactly the wrong instant.
 */
export const openerDraftKey: DraftKeySpec<OpenerRowKey> = {
  scope: 'opener',
  encode: ({ pairId, path }) => `${pairId}:${path}`
};

export const unwinderDraftKey: DraftKeySpec<UnwinderRowKey> = {
  scope: 'unwinder',
  encode: ({ pairId }) => pairId
};
